"use client";

import { useEffect, useRef } from "react";

export default function CTASection() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.remove("reveal-hidden");
            e.target.classList.add("reveal-active");
          }
        });
      },
      { threshold: 0.1 }
    );
    ref?.current?.querySelectorAll(".reveal-hidden")?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section className="py-32 md:py-44 px-6 md:px-10 bg-cream" ref={ref}>
      <div className="max-w-8xl mx-auto">
        <div
          className="relative rounded-5xl overflow-hidden flex items-center justify-center text-center"
          style={{
            background: 'var(--forest)',
            minHeight: '480px',
            padding: '80px 40px',
          }}
        >
          {/* Botanical SVG pattern overlay */}
          <div className="absolute inset-0 opacity-[0.04] pointer-events-none"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='120' height='120' viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff'%3E%3Ccircle cx='60' cy='60' r='2'/%3E%3Ccircle cx='20' cy='20' r='1.5'/%3E%3Ccircle cx='100' cy='20' r='1.5'/%3E%3Ccircle cx='20' cy='100' r='1.5'/%3E%3Ccircle cx='100' cy='100' r='1.5'/%3E%3Cpath d='M60 10 Q70 30 60 50 Q50 30 60 10z' fill-opacity='0.5'/%3E%3Cpath d='M10 60 Q30 70 50 60 Q30 50 10 60z' fill-opacity='0.5'/%3E%3Cpath d='M70 60 Q90 70 110 60 Q90 50 70 60z' fill-opacity='0.5'/%3E%3Cpath d='M60 70 Q70 90 60 110 Q50 90 60 70z' fill-opacity='0.5'/%3E%3C/g%3E%3C/svg%3E")`,
              backgroundSize: '120px 120px',
            }}
          />
          {/* Radial glow */}
          <div className="absolute inset-0 pointer-events-none"
            style={{ background: 'radial-gradient(ellipse at center, rgba(122,158,126,0.12) 0%, transparent 70%)' }} />

          <div className="relative z-10 max-w-2xl">
            <span className="reveal-hidden text-xs uppercase tracking-widest font-semibold mb-6 block" style={{ color: 'var(--gold)' }}>
              Comece Hoje
            </span>
            <h2 className="reveal-hidden reveal-delay-1 font-serif text-cream leading-tight mb-6"
              style={{ fontSize: 'clamp(2.2rem, 5vw, 3.8rem)' }}>
              Descubra os benefícios do Pilates{" "}
              <span className="italic font-light" style={{ color: 'var(--gold-light)' }}>para sua saúde.</span>
            </h2>
            <p className="reveal-hidden reveal-delay-2 leading-relaxed mb-12" style={{ color: 'rgba(250,248,242,0.65)', fontSize: '1.1rem' }}>
              Primeira aula experimental gratuita. Venha conhecer nosso espaço e equipe.
            </p>
            <div className="reveal-hidden reveal-delay-3 flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="https://wa.me/5551999999999?text=Olá! Gostaria de agendar minha aula experimental gratuita."
                target="_blank"
                rel="noopener noreferrer"
                className="btn-hero-gold"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                </svg>
                Agendar Aula Experimental
              </a>
              <a
                href="/contact"
                className="btn-ghost-white"
              >
                Falar com a equipe
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}